module.exports = __webpack_public_path__ + "img/img_009@2x.dcb900d8.png";